import { IsBoolean, IsInt, IsNotEmpty, IsNumber, IsString } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../../../../common/src/builders/error-message.builder';

export class RolloverSharesClassShareholderResult {
  // StringType
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  shareholderId: string;

  // StringType
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  title: string;

  // NumberType
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  numberOfShares: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  adjustedCostBase: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  fairMarketValue: number;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isSeller: boolean;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalPaidUpCapital: number;
}